"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const testUtils_1 = require("../../utils/testUtils");
const withSpacing_1 = __importDefault(require("../../hoc/withSpacing"));
const styles = require('./Heading.module.scss');
const Heading = ({ children, className = '', displayAs, id, level, noMargin, typeIdOptions, }) => {
    const Tag = `h${level}`;
    return (react_1.default.createElement(Tag, Object.assign({ className: (0, classnames_1.default)(styles.root, {
            [styles.noMargin]: noMargin,
            [styles[`h${level}`]]: !!level && !displayAs,
            [styles[`h${displayAs}`]]: !!displayAs,
            [className]: !!className,
        }), id: id }, (0, testUtils_1.getDataTypeAttribute)(typeIdOptions)), children));
};
exports.default = (0, react_1.memo)((0, withSpacing_1.default)(Heading));
//# sourceMappingURL=Heading.js.map